import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TourComponent} from './tour.component';
import {TourRoutingModule} from './tour-routing.module';
import {TourNgxBootstrapModule} from 'ngx-tour-ngx-bootstrap';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [TourComponent],
  imports: [
    CommonModule,
    TourRoutingModule,
    TourNgxBootstrapModule.forRoot(),
    TranslateModule,
  ],
  exports: [
    TourComponent
  ]
})
export class TourModule {
}
